/**
 * Owner, owning group and the permission string of a Data Lake path (S8 Task 8.11). The sticky bit is shown, never
 * edited (out of scope). Changing the owner on a connection that is not the account's super-user shows the row-A2 fact:
 * only Storage Blob Data Owner can hand ownership on (the owning user cannot); a Shared Key / Owner caller keeps its own
 * rights after a change (row A12), so no "you will lose access" warning exists.
 */
import { Input } from '../../../../../components/ui/input';
import { Label } from '../../../../../components/ui/label';

export const OWNER_CHANGE_NOTE = 'Changing the owner needs Storage Blob Data Owner; the owning user cannot hand ownership to someone else.';
export const GROUP_CHANGE_NOTE = 'Changing the owning group needs Storage Blob Data Owner, or being the owning user and a member of the new group.';

type Props = {
  owner: string;
  group: string;
  loadedOwner: string;
  loadedGroup: string;
  permissions: string;
  stickyBit: boolean;
  superUser: boolean;
  lockedReason?: string;
  onOwnerChange: (value: string) => void;
  onGroupChange: (value: string) => void;
};

export function AclOwnerFields(props: Props) {
  const ownerChanged = props.owner.trim() !== props.loadedOwner;
  const groupChanged = props.group.trim() !== props.loadedGroup;
  return (
    <div className="grid gap-2 text-xs" data-testid="hns-acl-owner-fields">
      <div className="grid grid-cols-2 gap-2">
        <div className="grid gap-1"><Label htmlFor="hns-acl-owner">Owner</Label>
          <Input spellCheck={false} autoComplete="off" id="hns-acl-owner" className="h-7 text-xs" value={props.owner} disabled={!!props.lockedReason} title={props.lockedReason} onChange={(event) => props.onOwnerChange(event.target.value)} data-testid="hns-acl-owner" /></div>
        <div className="grid gap-1"><Label htmlFor="hns-acl-group">Owning group</Label>
          <Input spellCheck={false} autoComplete="off" id="hns-acl-group" className="h-7 text-xs" value={props.group} disabled={!!props.lockedReason} title={props.lockedReason} onChange={(event) => props.onGroupChange(event.target.value)} data-testid="hns-acl-group" /></div>
      </div>
      <p className="text-muted-foreground" data-testid="hns-acl-permissions">
        Permissions <span className="font-mono">{props.permissions}</span>{props.stickyBit ? ' · sticky bit set (shown only; Jam SQL does not change it)' : ''}
      </p>
      {ownerChanged && !props.superUser && <p className="text-warning" data-testid="hns-acl-owner-note">{OWNER_CHANGE_NOTE}</p>}
      {groupChanged && !props.superUser && <p className="text-warning" data-testid="hns-acl-group-note">{GROUP_CHANGE_NOTE}</p>}
    </div>
  );
}
